import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderKoActionButtonsCell, renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpFilterBar, LpFilterCell, LpPageHeader, LpSearchInput, LpTable, raw } from '~/design-system';
export class adminTrackingContracts_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminTrackingContracts-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.pagination = new pagination_template('adminTrackingContractsPagination', vm, this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultsInfo = new resultsInfo_template('adminTrackingContractsResultInfo', vm, this.caller);
        this.statusFilter = new listPageSelect_template('adminContractsStatusFilter', vm, this.caller);
        this.statusFilter.setLabel('Status');
        this.statusFilter.setShowLabelPrefix(true);
        this.statusFilter.setIcon('info');
        this.statusFilter.setOptions([
            { id: 'CURRENT', name: 'Current' },
            { id: 'FUTURE', name: 'Future' },
            { id: 'OLD', name: 'Old' },
        ]);
        this.statusFilter.bindValue(vm.status);
        this.channelFilter = new listPageSelect_template('adminContractsChannelFilter', vm, this.caller);
        this.channelFilter.setLabel('Channel');
        this.channelFilter.setShowLabelPrefix(true);
        this.channelFilter.setIcon('grid');
        this.channelFilter.bindValue(vm.channel);
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            contracts: ko.observableArray([]),
            campaignName: ko.observable(''),
            status: ko.observable('CURRENT'),
            channel: ko.observable(''),
            onClickCreate: function () { self.caller.createContract(); },
            onClickEdit: function (row) { self.caller.editContract(row.id); },
            onClickDuplicate: function (row) { self.caller.duplicateContract(row.id); },
            onFilterChange: function () { self.caller.filterOnChange(); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: 'Contracts',
            description: 'Manage tracking contracts and campaign caps.',
            icon: 'file-text',
            controls: LpFilterBar({
                className: 'contracts-control-bar',
                controls: html `
                        ${LpFilterCell({
                    search: true,
                    children: LpSearchInput({
                        placeholder: 'Campaign name',
                        attributes: {
                            'data-bind': 'value: campaignName, event: { change: onFilterChange }',
                        },
                    }),
                })}

                        ${LpFilterCell({
                    children: raw(this.statusFilter.getHtmlBuild()),
                })}

                        ${LpFilterCell({
                    children: raw(this.channelFilter.getHtmlBuild()),
                })}
                    `,
                actions: LpButton({
                    label: 'Create New Contract',
                    prefixIcon: 'plus',
                    size: 'base',
                    variant: 'primary',
                    attributes: {
                        'data-bind': 'click: onClickCreate',
                    },
                }),
            }),
        })}

            <div class="list-page-module contracts-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${this.getContractsTableHtml()}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultsInfo.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getContractsTableHtml() {
        const columns = this.getContractTableColumns();
        return renderKoDataTable({
            title: 'Contracts',
            titleIcon: 'file-text',
            caption: 'Tracking contracts and campaign caps',
            columns,
            className: 'contracts-table',
            children: this.getContractsTableBodyHtml(columns),
        });
    }
    getContractTableColumns() {
        return [
            {
                key: 'id',
                label: 'ID',
                resizable: true,
                width: 88,
                minWidth: 72,
            },
            {
                key: 'name',
                label: 'Campaign Name',
                resizable: true,
                width: 220,
                minWidth: 168,
            },
            {
                key: 'campaignCode',
                label: 'Campaign Code',
                resizable: true,
                width: 160,
                minWidth: 128,
            },
            {
                key: 'channel',
                label: 'Channel',
                resizable: true,
                width: 140,
                minWidth: 112,
            },
            {
                key: 'startDate',
                label: 'Start Date',
                resizable: true,
                width: 136,
                minWidth: 112,
            },
            {
                key: 'endDate',
                label: 'End Date',
                resizable: true,
                width: 136,
                minWidth: 112,
            },
            {
                key: 'currentMonthCap',
                label: 'Current Month Cap',
                resizable: true,
                width: 168,
                minWidth: 136,
            },
            {
                key: 'autoStatus',
                label: 'Auto Status',
                resizable: true,
                width: 136,
                minWidth: 112,
            },
            {
                key: 'partners',
                label: 'Partners',
                resizable: true,
                width: 112,
                minWidth: 96,
            },
            {
                key: 'actions',
                label: 'Actions',
                align: 'center',
                width: 104,
                minWidth: 96,
                required: true,
            },
        ];
    }
    getContractsTableBodyHtml(columns) {
        return html `
            ${LpTable.Body({
            attributes: {
                'data-bind': 'foreach: contracts',
            },
            children: LpTable.Row({
                children: html `
                        ${renderRecruitingTextCell({ column: columns[0], binding: 'id', className: 'contracts-table__id' })}
                        ${renderRecruitingTextCell({ column: columns[1], binding: 'name', className: 'contracts-table__name' })}
                        ${renderRecruitingTextCell({ column: columns[2], binding: 'campaignCode', className: 'contracts-table__code' })}
                        ${renderRecruitingTextCell({ column: columns[3], binding: 'channel', className: 'contracts-table__channel' })}
                        ${renderRecruitingTextCell({ column: columns[4], binding: '$data.startDateAsStr || $data.startDate || ""', className: 'contracts-table__date' })}
                        ${renderRecruitingTextCell({ column: columns[5], binding: '$data.endDateAsStr || $data.endDate || ""', className: 'contracts-table__date' })}
                        ${renderRecruitingTextCell({ column: columns[6], binding: 'currentMonthCap', className: 'contracts-table__cap' })}
                        ${renderRecruitingStatusCell({
                    column: columns[7],
                    textBinding: 'autoStatusLabel',
                    cssBinding: `
                                'task-status--success': autoStatusValue === 1,
                                'task-status--pending': autoStatusValue !== 1
                            `,
                    className: 'contracts-table__auto',
                })}
                        ${renderRecruitingTextCell({ column: columns[8], binding: 'partnerCount', className: 'contracts-table__partners' })}
                        ${renderKoActionButtonsCell({
                    column: columns[9],
                    className: 'list-page-table__actions list-page-table__actions--center',
                    actions: [
                        { ariaLabel: 'Edit', icon: 'pencil-simple', binding: 'click: $parent.onClickEdit' },
                        { ariaLabel: 'Duplicate', icon: 'copy', binding: 'click: $parent.onClickDuplicate' },
                    ],
                })}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: 'contracts().length === 0',
            title: 'No contracts found',
            description: 'No tracking contracts match the selected filters.',
            icon: 'file-text',
        })}
        `;
    }
    /**
     * Build the request payload from the current view model state.
     *
     * @return object
     */
    getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        return {
            campaignName: vm.campaignName(),
            status: vm.status(),
            channel: vm.channel(),
            pagination: this.getPaginationViewModel(),
        };
    }
    /**
     * Return the pagination partial view model.
     *
     * @return any
     */
    getPaginationViewModel() {
        return this.pagination ? this.pagination.getTemplateViewModel() : null;
    }
    /**
     * Apply reference data returned by the API to the view model.
     *
     * @param references any
     * @return void
     */
    setReferences(references) {
        this.channelFilter.setOptions([
            { id: '', name: 'All channels' },
            ...(references && references.channels ? references.channels : []).map((channel) => ({
                id: String(channel.id),
                name: channel.name,
            })),
        ]);
    }
    /**
     * Apply contract rows returned by the API to the view model.
     *
     * @param contracts Array<any>
     * @return void
     */
    setContracts(contracts) {
        this.getTemplateViewModel().contracts((contracts || []).map((contract) => ({
            ...contract,
            autoStatusValue: Number(contract.automaticTurnOn || 0) === 1 && Number(contract.automaticTurnOff || 0) === 1 ? 1 : 0,
            autoStatusLabel: Number(contract.automaticTurnOn || 0) === 1 && Number(contract.automaticTurnOff || 0) === 1 ? 'Auto On/Off' : 'Manual',
        })));
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        if (this.pagination) {
            this.pagination.setNumberItemToPaginate(totalCount);
        }
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalResults number
     * @param totalPages number
     * @param execTime number
     * @return void
     */
    setResultInfo(totalResults, totalPages, execTime) {
        this.resultsInfo.setNbResults(totalResults);
        this.resultsInfo.setNbPages(totalPages);
        this.resultsInfo.setExecutionTime(execTime);
    }
    /**
     * Reset the list pagination to the first page.
     *
     * @return void
     */
    resetPageNumber() {
        const paginationVm = this.getPaginationViewModel();
        if (paginationVm && typeof paginationVm.pageNumber === 'function') {
            paginationVm.pageNumber(1);
        }
    }
}
